<template>
  <div>
    <!-- TOPIC BREAKDOWN BLOCK -->
    <div class="topic-breakdown-block profile-block rounded-5">
      <div
        class="title-row d-flex justify-content-between align-items-center nowrap"
      >
        <!-- TITLE -->
        <div class="title-bold color_text text-uppercase">Topic Breakdown</div>

        <!-- SELECT WEEK -->
        <div class="week" v-if="false">
          <select class="form-control rounded-30">
            <option value="1">1 Week</option>
            <option value="3">2 Week</option>
            <option value="3">3 Week</option>
          </select>
        </div>
      </div>

      <!-- BREAKDOWN ROW -->
      <div class="breakdown-row row">
        <div class="row w-100 px-3" v-if="topics.length">
          <div
            class="col-12 col-md-6"
            v-for="(topic, index) in topics"
            :key="index"
          >
            <BreakdownCard
              :topic_img="topic.image"
              :topic="topic.topic"
              :trend_percent="Math.round(topic.topic_progress.score)"
              :trend_level="topic.topic_progress"
              :trend_direction="topic.topic_progress.direction"
            ></BreakdownCard>
          </div>
        </div>
        <div class="col-12" v-else>
          <div
            class="d-flex justify-content-center align-items-center color_ash font-14"
          >
            No Topic Breakdown Available
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <!-- SHOW MORE -->
        <div class="show-more mt-3" v-if="false">
          <div class="btn-link font-weight-bold" @click="showMoreTopic">
            See {{ text_addon }} Report
          </div>
        </div>

        <!-- TOPIC SETTINGS -->
        <template v-if="false">
          <a
            :href="topicSettingsURL"
            class="topic-settings d-flex justify-content-end brand_accent pointer"
            v-if="account_type === 'parent' || account_type === 'student'"
          >
            <div class="icon icon-gear"></div>
            <div class="text">Topic Settings</div>
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { TOPIC_BASE_URL } from "@/var";
import { mapGetters } from "vuex";
import { generateTokenString } from "@/scripts/utilities";

export default {
  name: "TopicBreakdown",

  props: ["topics"],

  components: {
    BreakdownCard: () =>
      import(
        /* webpackChunkName: "BreakdownCard" */ "@/components/profileComps/studentprofile/BreakdownCard"
      ),
  },

  computed: {
    ...mapGetters(["getAuthToken"]),

    topicSettingsURL() {
      return `${TOPIC_BASE_URL}/${generateTokenString(this.getAuthToken)}`;
    },
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      base_topic_list: [],
      topic_list: [],
      shrinked: true,
      text_addon: "",
      show_more: false,
    };
  },

  watch: {
    topics: {
      handler(newVal) {
        console.log(newVal);
        // if (newVal) this.loadTopics();
      },
      immediate: true,
    },
  },

  methods: {
    loadTopics() {
      this.base_topic_list = this.topics;
      this.topic_list = this.topics;
      if (this.topic_list.length > 10) {
        this.show_more = true;
        this.text_addon = "More";
        this.topic_list = this.topic_list.slice(0, 10);
      } else this.show_more = false;
    },

    showMoreTopic() {
      this.shrinked = !this.shrinked;
      if (this.shrinked) {
        if (this.topic_list.length > 10)
          this.topic_list = this.topic_list.slice(0, 10);
        this.text_addon = "More";
      } else {
        this.topic_list = this.base_topic_list;
        this.text_addon = "Less";
      }
    },
  },
};
</script>

<style lang="scss">
.topic-breakdown-block {
  .title-bold {
    @include breakpoint_max(sm) {
      font-size: 14px !important;
    }
  }
  .form-control {
    position: relative;
    background: $color_white;
    box-sizing: border-box;
    font-size: 12px;
    color: $color_text;
    padding: 2px 25px;

    &:focus {
      border: 1px solid $brand_accent;
    }
  }

  .week {
    position: relative;
    width: 100px;

    .form-control {
      &:focus {
        background: unset;
      }
    }

    &::after {
      position: absolute;
      content: "\25BE";
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 3;
      font-size: 20px;
      color: $color_text;
    }
  }

  .breakdown-row {
    margin-top: 22px;
  }

  .topic-settings {
    transition: all 0.3s ease-in-out;

    .icon {
      font-size: 21px;
      margin-right: 10px;
      position: relative;
      top: -1px;
    }
    .text {
      font-size: 14px;
      font-weight: 600;
    }

    &:hover {
      color: $brand_inverse !important;
    }
  }
}
</style>
